// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _TaobaoOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/TaobaoOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var TaobaoOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _TaobaoOutlined.default
    }));
};
/**![taobao](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE2OC41IDI3My43YTY4LjcgNjguNyAwIDEwMTM3LjQgMCA2OC43IDY4LjcgMCAxMC0xMzcuNCAwem03MzAgNzkuMnMtMjMuNy0xODQuNC00MjYuOS03MC4xYzE3LjMtMzAgMjUuNi00OS41IDI1LjYtNDkuNUwzOTYuNCAyMDVzLTQwLjYgMTMyLjYtMTEzIDE5NC40YzAgMCA3MC4xIDQwLjYgNjkuNCAzOS40IDIwLjEtMjAuMSAzOC4yLTQwLjYgNTMuNy02MC40IDE2LjEtNyAzMS41LTEzLjYgNDYuNy0xOS44LTE4LjYgMzMuNS00OC43IDgzLjgtNzguOCAxMTUuNmw0Mi40IDM3czI4LjgtMjcuNyA2MC40LTYxLjJoMzZ2NjEuOEgzNzIuOXY0OS41aDE0MC4zdjExOC41Yy0xLjcgMC0zLjYgMC01LjQtLjItMTUuNC0uNy0zOS41LTMuMy00OS0xOC4yLTExLjUtMTguMS0zLTUxLjUtMi40LTcxLjloLTk3bC0zLjQgMS44cy0zNS41IDE1OS4xIDEwMi4zIDE1NS41YzEyOS4xIDMuNiAyMDMtMzYgMjM4LjYtNjMuMWwxNC4yIDUyLjYgNzkuNi0zMy4yLTUzLjktMTMxLjktNjQuNiAyMC4xIDEyLjEgNDUuMmMtMTYuNiAxMi40LTM1LjYgMjEuNy01Ni4yIDI4LjRWNTYxLjNoMTM3LjF2LTQ5LjVINjI4LjFWNDUwaDEzNy42di00OS41SDUyMS4zYzE3LjYtMjEuNCAzMS41LTQxLjEgMzUtNTMuNmwtNDIuNS0xMS42YzE4Mi44LTY1LjUgMjg0LjUtNTQuMiAyODMuNiA1My4ydjI4Mi44czEwLjggOTcuMS0xMDAuNCA5MC4xbC02MC4yLTEyLjktMTQuMiA1Ny4xUzg4Mi41IDg4MCA5MDMuNyA2ODAuMmMyMS4zLTIwMC01LjItMzI3LjMtNS4yLTMyNy4zem0tNzA3LjQgMTguM2wtNDUuNCA2OS43IDgzLjYgNTIuMXM1NiAyOC41IDI5LjQgODEuOUMyMzMuOCA2MjUuNSAxMTIgNzM2LjMgMTEyIDczNi4zbDEwOSA2OC4xYzc1LjQtMTYzLjcgNzAuNS0xNDIgODkuNS0yMDAuNyAxOS41LTYwLjEgMjMuNy0xMDUuOS05LjQtMTM5LjEtNDIuNC00Mi42LTQ3LTQ2LjYtMTEwLTkzLjR6IiAvPjwvc3ZnPg==) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(TaobaoOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'TaobaoOutlined';
}
var _default = RefIcon;
